import React, { Component } from 'react'
import { observer } from 'mobx-react'
import classnames from 'classnames'

import Websites from '../stores/websites'

const WebsiteChooser = ({websites}) => (
  <div className="websites">
    {websites && websites.map(website => (
      <label key={website.id} className={classnames({ disabled: website.provisioned })}>
        <input type="radio" name="website_id" value={website.id} disabled={website.provisioned} />
        {website.name}
      </label>
    ))}
  </div>
)

@observer
class Provision extends Component {
  state = {
    websites: new Websites(),
    processing: false,
    error: false
  }

  componentWillMount() {
    this.state.websites.load()
  }

  handleSubmit = event => {
    event.preventDefault()
    this.setState({ processing: true })

    const { installation_uuid } = this.props.params
    const { website_id } = this.form

    this.state.websites.provision(website_id.value, installation_uuid)
      .then(() => location.href = this.props.location.query.return_to)
      .catch(() => this.setState({ error: true, processing: false }))
  }

  render() {
    const { websites, processing } = this.state

    const errorMessage = this.state.error && <div className="error">Error activating website.</div>

    const activeWebsites = websites.loaded && Object.values(websites.websites).filter(w => w.active)

    const noActiveWebsitesMessage = activeWebsites && !activeWebsites.length && <div className="warn">You Have No Websites To Activate.</div>

    return (
      <div className="container provision">
        <div className="dialog provision">
          <form onSubmit={this.handleSubmit} ref={f => this.form = f}>
            <h2>Activate Your Wordpress Plugin</h2>
            <p>Choose a website below to link to your Wordpress plugin:</p>

            {errorMessage}
            {noActiveWebsitesMessage}
            <WebsiteChooser websites={activeWebsites} />

            <button type="submit" disabled={!activeWebsites || !activeWebsites.length || processing}>
              Activate Website
            </button>
          </form>
        </div>
      </div>
    )
  }
}

export default Provision



// WEBPACK FOOTER //
// client/components/Provision.js